export function createObjectCopy(object) {
    return JSON.parse(JSON.stringify(object));
}